import { useState } from 'react';
import { Box, Button, TextField, Typography, Divider } from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';

const VisitorPass = ({ form, setForm, setStatus, clearForm, customisations }) => {
   const [visitorPass, setVisitorPass] = useState(() => {
      if (form?.visitorPass !== undefined) {
         return form.visitorPass;
      }
      return '';
   });

   const label = customisations?.visitorPassLabel || 'Visitor Pass Number';

   async function saveVisitorPass() {
      setForm({ ...form, visitorPass });
      setStatus('step2');
   }
   async function goBack() {
      if (customisations?.contactNumber) {
         setStatus('contactNumber');
      } else if (customisations?.carReg) {
         setStatus('carReg');
      } else {
         setStatus('step1');
      }
   }

   return (
      <Box sx={{ width: '100%' }}>
         <Typography variant="h5" align="center">
            {label}
         </Typography>
         <Typography variant="body1" align="center">
            Please enter the number on your physical visitor pass.
         </Typography>
         <Box
            sx={{
               display: 'flex',
               flexDirection: 'row',
               gap: 3,
               mb: 3,
               justifyContent: 'space-between',
               width: '100%',
               mt: 1,
            }}
         >
            <Box sx={{ width: '15%', mt: 2 }}>
               <Button
                  onClick={goBack}
                  sx={{ height: '130px' }}
                  fullWidth
                  variant="outlined"
                  color="primary"
               >
                  Back
               </Button>
            </Box>
            <Box sx={{ minWidth: '70%', flexDirection: 'column' }}>
               <TextField
                  value={visitorPass}
                  onChange={(e) => setVisitorPass(e.target.value)}
                  label={label}
                  variant="outlined"
                  margin="normal"
                  fullWidth
               />
            </Box>

            <Box sx={{ width: '15%', mt: 2, display: 'flex', alignItems: 'flex-start' }}>
               <Button
                  onClick={saveVisitorPass}
                  variant="contained"
                  fullWidth
                  sx={{ height: '130px' }}
                  color="primary"
               >
                  {visitorPass === '' ? 'Skip' : 'Next'}
               </Button>
            </Box>
         </Box>
         <Divider sx={{ width: '100%' }} />
         <Box sx={{ width: '100%', mt: 2, display: 'flex', justifyContent: 'center' }}>
            <Button onClick={clearForm} startIcon={<ReplayIcon />} color="primary">
               Start again
            </Button>
         </Box>
      </Box>
   );
};

export default VisitorPass;
